import {
  Dialog,
  IconButton,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core"
import { FC, useState } from "react"
import { useQueryClient } from "@tanstack/react-query"
import { useDeleteResourceByIdMutation } from "../../generated/graphql"
import { useGraphQLClient } from "../../hooks/useGraphQLClient"
import { Query } from "../../utils/constants"
import { colors, theme } from "../../utils/theme"
import { GhostButton, PrimaryButton } from "../atoms/button/Button"
import CloseIcon from "../atoms/CloseIcon"
import MoreIcon from "../atoms/MoreIcon"

const useStyles = makeStyles({
  moreButton: {
    fill: colors.neutral.denim,
    stroke: colors.neutral.denim,
    "&:hover": {
      fill: colors.neutral.asphalt,
      stroke: colors.neutral.asphalt,
    },
    "&:active": {
      fill: colors.primary.periwinkle,
      stroke: colors.primary.periwinkle,
    },
    "&:focus": {
      fill: colors.primary.shadow,
      stroke: colors.primary.shadow,
    },
  },
  dialogPaper: {
    border: `1px solid ${colors.neutral.clay}`,
    boxShadow: "none",
  },
  dialogCloseContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(1),
  },
  dialogContent: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(5),
    alignContent: "center",
    justifyContent: "center",
  },
  closeButton: {
    margin: 0,
    padding: 0,
    border: 0,
    height: theme.spacing(2),
    width: theme.spacing(2),
    backgroundColor: "transparent",
    cursor: "pointer",
    "&:focus": {
      outline: "none",
    },
  },
  menuDestroy: {
    backgroundColor: colors.tertiary.orange,
  },
  dialogTitle: {
    color: colors.neutral.denim,
    marginBottom: 12,
  },
  dialogSubtitle: {
    color: colors.neutral.denim,
    marginBottom: theme.spacing(3),
  },
  confirmButton: {
    marginBottom: theme.spacing(2),
    width: "100%",
  },
  cancelContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  menuPaper: {
    borderRadius: 4,
    border: "1px solid rgba(0, 0, 0, 0.1)",
    backgroundColor: colors.neutral.white,
    boxShadow:
      "0px 0px 4px rgba(54, 53, 69, 0.1), 0px 3px 12px rgba(54, 53, 69, 0.05)",
  },
  iconButton: {
    "&:hover": {
      backgroundColor: "transparent",
      boxShadow: "none",
      outline: "none",
    },
    "&:focus": {
      outline: "none",
    },
  },
})

interface Props {
  id: number
  canOpen: boolean
}
const InAppResourcesMoreButton: FC<Props> = ({ id, canOpen }) => {
  const classes = useStyles()
  const [openShareDialog, setOpenShareDialog] = useState<boolean>(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const graphQLClient = useGraphQLClient()
  const queryClient = useQueryClient()
  const onSuccessDelete = () => {
    queryClient.invalidateQueries({ queryKey: [Query.GET_IN_APP_RESOURCES] })
  }
  const { mutate: deleteResource } = useDeleteResourceByIdMutation(
    graphQLClient,
    {
      onSuccess: () => onSuccessDelete(),
    }
  )
  return (
    <>
      <IconButton
        onClick={(event) => setAnchorEl(event.currentTarget)}
        className={classes.iconButton}
        classes={{ label: classes.moreButton }}
      >
        <MoreIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        keepMounted={true}
        open={Boolean(anchorEl) && canOpen}
        onClose={() => setAnchorEl(null)}
        classes={{
          paper: classes.menuPaper,
        }}
      >
        <MenuItem
          className={classes.menuDestroy}
          onClick={() => {
            setAnchorEl(null)
            setOpenShareDialog(true)
          }}
        >
          Delete
        </MenuItem>
      </Menu>

      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={openShareDialog}
        onClose={() => setOpenShareDialog(false)}
        classes={{
          paper: classes.dialogPaper,
        }}
      >
        <div className={classes.dialogContent}>
          <div className={classes.dialogCloseContainer}>
            <button
              className={classes.closeButton}
              onClick={() => setOpenShareDialog(false)}
            >
              <CloseIcon />
            </button>
          </div>
          <Typography
            variant="h2"
            component="h1"
            className={classes.dialogTitle}
          >
            Remove Resource
          </Typography>
          <Typography variant="body1" className={classes.dialogSubtitle}>
            {"Are you sure you want to remove? " +
              "This will permanently delete this resource."}
          </Typography>
          <PrimaryButton
            onClick={() => {
              setLoading(true)
              setLoading(false)
              setOpenShareDialog(false)
              deleteResource({ id: id })
            }}
            className={classes.confirmButton}
            type="submit"
            disabled={loading}
          >
            Confirm
          </PrimaryButton>
          <div className={classes.cancelContainer}>
            <GhostButton onClick={() => setOpenShareDialog(false)}>
              Cancel
            </GhostButton>
          </div>
        </div>
      </Dialog>

      {/* <Dialog
        fullWidth={true}
        maxWidth="xs"
        open={openReaddDialog}
        onClose={() => setOpenReaddDialog(false)}
        classes={{
          paper: classes.dialogPaper,
        }}
      >
        <div className={classes.dialogContent}>
          <div className={classes.dialogCloseContainer}>
            <button
              className={classes.closeButton}
              onClick={() => setOpenReaddDialog(false)}
            >
              <CloseIcon />
            </button>
          </div>
          <Typography
            variant="h2"
            component="h1"
            className={classes.dialogTitle}
          >
            Re-Add Client
          </Typography>
          <Typography variant="body1" className={classes.dialogSubtitle}>
            {`Are you sure you want to re-add ${firstName} ${lastName}?`}
          </Typography>
          <PrimaryButton
            onClick={() => {
              setLoading(true)
              updateInviteCodeStatus({
                code,
                status: InviteCodeStatus.PENDING,
              })
              API.scheduleConnectPractitionerNotification(code.toUpperCase())
              setLoading(false)
              setOpenReaddDialog(false)
            }}
            className={classes.confirmButton}
            type="submit"
            disabled={loading}
          >
            Confirm
          </PrimaryButton>
          <div className={classes.cancelContainer}>
            <GhostButton onClick={() => setOpenReaddDialog(false)}>
              Cancel
            </GhostButton>
          </div>
        </div>
      </Dialog> */}
    </>
  )
}

export default InAppResourcesMoreButton
